import { Directive, HostListener, inject } from '@angular/core';

import { AnalyticEvent, AnalyticsService } from '@core/analytics';

// Fires a single AnalyticEvent.Scroll the first time the user scrolls near the
// bottom of the page. Extracted from AppComponent.onWindowScroll and attached to
// the app root via hostDirectives.
@Directive({
    selector: '[scrollDepthAnalytics]',
    standalone: true,
})
export class ScrollDepthAnalytics {
    private readonly analytics = inject(AnalyticsService);
    private triggered = false;

    @HostListener('window:scroll')
    onScroll(): void {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const threshold = 300;

        if (scrollTop + windowHeight >= documentHeight - threshold && !this.triggered) {
            this.analytics.logEvent(AnalyticEvent.Scroll);
            this.triggered = true;
        }
    }
}
